define('Components/CategoriesWidget/js/models/CategoriesWidgetInstanceModel',['jquery',
        'app',
        'WidgetInstanceModel',
        'UrlFactory'
    ],
    function ($, app, WidgetInstanceModel, UrlFactory) {
        return WidgetInstanceModel.extend({
            name:'CategoriesWidgetModel',
            getWidgetCategories: function() {
                var model = this
                var result = _([1, 2, 3]).map(function(i) {
                    var id = model.p('idcategory'+i)
                    if (!id) {
                        return false
                    }
                    var category = app.getCategory(id)
                    if (!category) {
                        return false
                    }
                    var mobileImage = model.p('imageMobilecategory'+i) && model.p('imageMobilecategory'+i) !== '0'
                        ? app.getPictureUrl(model.p('imageMobilecategory'+i), 'widget', 'noscale', 'jpg')
                        : category.getPictureUrl()
                    var desktopImage = model.p('imageDesktopcategory'+i) && model.p('imageDesktopcategory'+i) !== '0'
                        ? app.getPictureUrl(model.p('imageDesktopcategory'+i), 'widget', 'noscale', 'jpg')
                        : category.getPictureUrl()
                    
                    var data = {
                        id: id,
                        title: model.p('titlecategory'+i) || category.getTitle(),
                        mobileImage: mobileImage,
                        desktopImage: desktopImage,
                        url: category.getUrl(),
                        model: category
                    }

                    return data
                })

                return _(result)
            }
        })
    });
